module.exports = __webpack_public_path__ + "static/media/b2bReservas.56c790be.ico";